module.exports = __webpack_public_path__ + "common/search/icon-kids-f25fcef5c09d20a643fee10090613c5b.svg";